$(document).ready(function() {
	if(!document.querySelector('.GPC0039')) return false;
	var $component = $(".GPC0039");
	var $snsArea =  $component.find('.sns-area');
	$snsArea.find('.sns').on('click', function(e){
		e.preventDefault();
		// 20200416 START ������ - SNS ��ũ ��ũ��Ʈ ����
		//if(typeof ePrivacyCookies=='undefined' || ePrivacyCookies.get('LGCOM_SOCIAL_MEDIA')) {
			var $snsLayer = $(this).closest('.sns-area').find('.list');
			if($snsLayer.hasClass('active')) {
				$snsLayer.removeClass('active left-side center');
			} else {
				$snsLayer.addClass('active');
				$('.download-sets-wrap').removeClass('active');
				
				if($snsLayer.offset().left < 0) {
					$snsLayer.addClass('left-side');
					var a = $snsLayer.offset().left + $snsLayer.width();
					var screenSize = $(window).innerWidth();
					var coponentSidePadding = parseInt(window.getComputedStyle($component[0], null).getPropertyValue("padding-left"));
					if( a >= screenSize - (coponentSidePadding*2) ){
						$snsLayer.removeClass('left-side');
						$snsLayer.addClass('center');
					}
				}
			}
		//} else {
		//	ePrivacyCookies.view('click');
		//}
		// 20200416 END
	});
	// popover download manuals
	var manuals = {
		checker : false,
		activeClass : "active",
	}
	var activeEvent = function(tg){
		manuals.checker ? tg.addClass(manuals.activeClass) : tg.removeClass(manuals.activeClass);
		$snsArea.find('.list').removeClass('active');
	}
	// mouse
	$component.find(".control").on("click", ".btn-list-toggle", function(e){
		e.preventDefault();
		var $elem = $(this).siblings(".download-sets-wrap");
		manuals.checker = !manuals.checker;
		activeEvent($elem);
	});
	$component.find(".btn-dowload-set-close").on("click blur", function(){
		var $elem = $(this).parent();
		manuals.checker = false;
		activeEvent($elem);
	});
});
